/**
 * Scheduler list states the launch page tiles open. Each is the state the server counted for
 * that tile, so the tile count and the list total are the same number.
 */
export const SCHEDULER_TILE_STATE = {
  pendingCoCm: 'pending_data_enrichment',
  availableToSchedule: 'ready_for_scheduling',
  pendingScheduling: 'pending_scheduling',
  declinedTentative: 'declined_tentative'
} as const;

export type SchedulerTileState = (typeof SCHEDULER_TILE_STATE)[keyof typeof SCHEDULER_TILE_STATE];

export function schedulerListRoute(state: SchedulerTileState): string {
  return `/scheduler?${new URLSearchParams({ state })}`;
}

/** Tab labels for the tile-only states, which the Scheduler tabs do not otherwise offer. */
export const SCHEDULER_TILE_LABEL = {
  [SCHEDULER_TILE_STATE.pendingScheduling]: 'Pending Scheduling',
  [SCHEDULER_TILE_STATE.declinedTentative]: 'Declined/Tentative Meetings'
};
